export const getCreditCardCompany = (cardNumber) => {
  if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cardNumber)) {
    return 'VISA';
  } else if (/^5[1-5][0-9]{14}$/.test(cardNumber) || /^2(2[2-9][0-9]{2}|[3-6][0-9]{3}|7[01][0-9]{2}|720[0-9]{2})[0-9]{10}$/.test(cardNumber)) {
    return 'MasterCard';
  } else if (/^3[47][0-9]{13}$/.test(cardNumber)) {
    return 'Amex';
  } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cardNumber)) {
    return 'DinersClub';
  } else if (/^6(?:011|5[0-9]{2}|22[1-9]|2[3-9][0-9])[0-9]{12}$/.test(cardNumber)) {
    return 'Discover';
  } else if (/^35[0-9]{14}$/.test(cardNumber)) {
    return 'JCB';
  } else if (/^62[0-9]{14,17}$/.test(cardNumber)) {
    return 'UnionPay';
  }
  return null;
}

export const formatCardNumber = (cardNumber) => {
  const company = getCreditCardCompany(cardNumber);
  switch (company) {
    case 'VISA':
    case 'MasterCard':
    case 'Discover':
    case 'JCB':
    case 'UnionPay':
      // 16桁の場合: 4-4-4-4 のフォーマット
      return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
    case 'Amex':
      // 15桁の場合: 4-6-5 のフォーマット
      return cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
    case 'DinersClub':
      // 14桁の場合: 4-6-4 のフォーマット
      return cardNumber.replace(/(\d{4})(\d{6})(\d{4})/, '$1 $2 $3');
    default:
      return cardNumber; // フォーマット不明の場合はそのまま返す
  }
}